module.exports = __webpack_public_path__ + "media/images/checkbox_active-571fe01fd46a4c7102fa15751fda188e.svg";